import React, { useCallback, useRef } from 'react';
import { findDOMNode } from 'react-dom';
import EventListener, { withOptions } from 'react-event-listener';
import Portal from '../Portal';
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Escape"] = 27] = "Escape";
})(KeyCode || (KeyCode = {}));
export var CloseType;
(function (CloseType) {
    CloseType["ClickOutside"] = "CLICK_OUTSIDE";
    CloseType["Keyboard"] = "KEYBOARD";
    CloseType["CloseButton"] = "CLOSE_BUTTON";
})(CloseType || (CloseType = {}));
export const AccessiblePortal = ({ isOpen, children, closeOnEsc, closeOnOutsideClick, triggerNode, onRequestClose, node }) => {
    const portalRef = useRef();
    const handleOutsideMouseClick = ({ target, button }) => {
        const root = findDOMNode(portalRef.current); // eslint-disable-line react/no-find-dom-node
        const isClickedInsidePortal = root && root.contains(target);
        const isClosedByTrigger = triggerNode === null || triggerNode === void 0 ? void 0 : triggerNode.contains(target);
        const isNotMainButtonClicked = !!button && button !== 0;
        if (isNotMainButtonClicked || isClickedInsidePortal || isClosedByTrigger) {
            return;
        }
        onRequestClose({ closeType: CloseType.ClickOutside });
    };
    const handleKeyDown = useCallback(({ keyCode }) => isOpen &&
        keyCode === KeyCode.Escape &&
        onRequestClose({ closeType: CloseType.Keyboard }), [isOpen, onRequestClose]);
    if (!isOpen) {
        return null;
    }
    return (React.createElement(Portal, { node: node, key: "react-portal", ref: portalRef },
        children,
        closeOnEsc && (React.createElement(EventListener, { target: "document", onKeyDown: handleKeyDown })),
        closeOnOutsideClick && (React.createElement(EventListener, { target: "document", onMouseUp: handleOutsideMouseClick, onTouchStart: withOptions(handleOutsideMouseClick, {
                passive: true
            }) }))));
};
//# sourceMappingURL=AccessiblePortal.js.map